import { AssignmentEditModalForm } from "./AssignmentEditModalForm"


const AssignmentEditModalFormWrapper = () => {
    return (<AssignmentEditModalForm />)
}

export {AssignmentEditModalFormWrapper}